import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CopyAccountRequest, CopyToSitesRequest } from '@app/models/fund-management';

@Injectable()
export class AccountCopyService {
	accountCopyEndpointBase = '/api/account-copy';

	constructor(private readonly http: HttpClient) {}

	getSitesForCopy(): Observable<any> {
		return this.http.get(`${this.accountCopyEndpointBase}/getSitesForCopy`);
	}

	getRolesForCopy(): Observable<any> {
		return this.http.get(`${this.accountCopyEndpointBase}/getRolesForCopy`);
	}

	copyToSites(request: CopyToSitesRequest): Observable<any> {
		return this.http.post(`${this.accountCopyEndpointBase}/copyToSites`, request);
	}

	copyAccount(request: CopyAccountRequest): Observable<any> {
		return this.http.post(`${this.accountCopyEndpointBase}/copyAccount`, request);
	}
}
